<template>
    <div class="news-detail" :message="detailMsg">
        <h2 class="common-font">{{detailMsg.title}}</h2>
        <p>{{detailMsg.msg}}</p>
    </div>
</template>

<script>
    export default {
        name: "message",
        props:['detailMsg']
    }
</script>

<style lang="less">
.news-detail{
    .common-font{
        font-family: 'Gotham-Medium',"Avenir Next", 'Helvetica Neue', 'PingFang SC';
        font-weight: 500;
    }
    h2{
        font-size: 28px;
        color: #252525;
        line-height: 48px;
        margin-bottom: 24px;
    }
    p{
        font-size: 14px;
        line-height: 22px;
        color: #5D5D5D;

    }
}
</style>



// WEBPACK FOOTER //
// src/common/message.vue